import React from "react";
import { HiArrowUp } from "react-icons/hi2";
import SocialIcon from "../components/ui/SocialIcon";
import { SITE, SOCIALS, NAV_LINKS } from "../data/portfolio";

function Footer() {
  const year = new Date().getFullYear();

  const toTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="border-t border-line bg-bg-soft/60">
      <div className="container-page flex flex-col gap-10 py-14">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <a
              href="#home"
              className="font-display text-lg font-bold text-ink no-underline"
            >
              abdullah<span className="text-accent-soft">.dev</span>
            </a>
            <p className="mt-3 text-sm text-ink-faint">
              {SITE.role} based in {SITE.location}. Building web, IoT and ML products
              end-to-end.
            </p>
          </div>

          <nav className="flex flex-wrap gap-x-8 gap-y-2">
            {NAV_LINKS.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                className="text-sm text-ink-muted no-underline transition-colors hover:text-accent-soft"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-line pt-6 sm:flex-row">
          <p className="text-xs text-ink-faint">
            © {year} {SITE.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="grid h-9 w-9 place-items-center rounded-lg border border-line bg-white/5 text-ink-muted transition-all hover:-translate-y-0.5 hover:border-accent/50 hover:text-accent-soft"
              >
                <SocialIcon name={s.icon} />
              </a>
            ))}
            <button
              onClick={toTop}
              aria-label="Back to top"
              className="grid h-9 w-9 place-items-center rounded-lg border border-line bg-white/5 text-ink-muted transition-all hover:-translate-y-0.5 hover:border-accent/50 hover:text-accent-soft"
            >
              <HiArrowUp />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
